import axios from "axios";
import { IS_BIZ_HOST, IS_ADMIN_HOST, ON_CUSTOM_DOMAIN } from "@/lib/site";

// Each live address (goperks.au, business., admin.) talks to the backend on its own address so sign-in cookies stay first-party.
const API_ORIGIN = IS_BIZ_HOST || IS_ADMIN_HOST || ON_CUSTOM_DOMAIN ? window.location.origin : process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${API_ORIGIN}/api`,
  withCredentials: true,
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    const url = original?.url || "";
    if (error.response?.status === 401 && !original._retry && !url.includes("/auth/")) {
      original._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(original);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function formatErr(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail?.msg || String(detail);
}

export const CATEGORIES = [
  { key: "cafes", label: "Cafes & Brunch", img: "https://images.unsplash.com/photo-1509440159596-0249088772ff?auto=format&fit=crop&w=1000&q=80" },
  { key: "kids", label: "Kids Activities", img: "https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?auto=format&fit=crop&w=1000&q=80" },
  { key: "dining", label: "Dining Out", img: "https://images.unsplash.com/photo-1513104890138-7c749659a591?auto=format&fit=crop&w=1000&q=80" },
  { key: "family-fun", label: "Family Fun", img: "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?auto=format&fit=crop&w=1000&q=80" },
  { key: "essentials", label: "Everyday Essentials", img: "https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=1000&q=80" },
  { key: "travel", label: "Holidays & Travel", img: "https://images.unsplash.com/photo-1470770841072-f978cf4d019e?auto=format&fit=crop&w=1000&q=80" },
];

export const catLabel = (k) => CATEGORIES.find((c) => c.key === k)?.label ?? k;
